import { homeService } from '../_services/';
import alerts from '../_components/alerts';
import { stringUtils } from '../_utils/stringUtils';

export const homeAction = {
    getHome,
    onChangeProps,
    editHomeInfo,
    clear
};

function getHome(filterModel, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'chamadas/export' + stringUtils.serialize(filterModel);
        console.log('apiEndpoint', apiEndpoint);
        homeService.get(apiEndpoint)
            .then((response) => {
                if (response.data) {
                    if (response.data.graficoTanques != null) {
                        response.data.graficoTanques = {
                            options: {
                                colors: ['var(--primary-color)', '#000000'],
                                chart: {
                                    id: "basic-bar",
                                    animations: {
                                        speed: 300
                                    },
                                },
                                dataLabels: {
                                    position: 'top',
                                    enabled: false,
                                    style: {
                                        fontWeight: 'normal',
                                        colors: ['#000']
                                    },
                                    offsetY: -20
                                },
                                plotOptions: {
                                    bar: {
                                        distributed: false,
                                        horizontal: false,
                                        dataLabels: {
                                            position: 'top',
                                            fontWeight: 'normal'
                                        }
                                    }
                                },
                                xaxis: {
                                    enabled: false,
                                    labels: {
                                        rotate: -45,
                                        type: 'category',
                                    },
                                    style: {
                                        fontSize: '7px'
                                    },
                                    categories: response.data.graficoTanques.options
                                },
                                yaxis: {
                                    labels: {
                                        formatter: function (val, index) {
                                            return "R$ " + val.toLocaleString('pt-br', { minimumFractionDigits: 2 });
                                        }
                                    }
                                },
                                tooltip: {
                                    y: {
                                        formatter: function (value, { series, seriesIndex, dataPointIndex, w }) {
                                            //formata a série[0], que é a do faturamento
                                            if (seriesIndex == 0) {
                                                return "R$ " + value.toLocaleString('pt-br', { minimumFractionDigits: 2 })
                                            } else {
                                                return value
                                            }
                                        }
                                    }
                                }
                            },
                            series: [
                                {
                                    name: "Faturamento",
                                    data: response.data.graficoTanques.series[0],
                                    colors: 'var(--primary-color)',
                                },
                                {
                                    name: "Volume",
                                    data: response.data.graficoTanques.series[1],
                                    colors: '#000000'
                                }
                            ]
                        };
                    } else {
                        response.data.graficoTanques = {
                            options: {},
                            series: []
                        }
                    }
                    if (response.data.graficoAnimaisGrupos != null) {
                        response.data.graficoAnimaisGrupos = {
                            series: response.data.graficoAnimaisGrupos.series[0],
                            options: {
                                colors: ['var(--primary-color)', '#cc2d42', '#d4ae33', '#426cf5', '#b36ba2'],
                                chart: {
                                    type: 'pie',
                                },
                                legend: {
                                    position: 'bottom'
                                },
                                labels: response.data.graficoAnimaisGrupos.options,
                                dataLabels: {
                                    enabled: true,
                                    formatter: function (val, opt) {
                                        var i = opt.seriesIndex;
                                        return val.toFixed(2) + '% (' + opt.w.globals.series[i] + ')';
                                    },
                                    style: {
                                        colors: ['#000'],
                                        fontWeight: 'bold'
                                    },
                                    dropShadow: {
                                        enabled: false,
                                        top: 1,
                                        left: 1,
                                        blur: 1,
                                        color: '#000',
                                        opacity: 0.45
                                    },
                                },
                                plotOptions: {
                                    pie: {
                                        dataLabels: {
                                            position: 'top',
                                            offset: -10,
                                        }
                                    }
                                },
                            },
                            responsive: [{
                                breakpoint: 480,
                                options: {
                                    chart: {
                                        width: 200
                                    },
                                    legend: {
                                        position: 'bottom',
                                        fontWeight: 'normal'
                                    }
                                }
                            }]
                        };
                    } else {
                        response.data.graficoAnimaisGrupos = {
                            options: {},
                            series: []
                        }
                    }
                    if (response.data.graficoDel != null) {
                        response.data.graficoDel = {
                            series: response.data.graficoDel.series[0],
                            options: {
                                colors: ['var(--primary-color)', '#cc2d42', '#d4ae33', '#426cf5', '#b36ba2'],
                                chart: {
                                    type: 'pie'
                                },
                                legend: {
                                    position: 'bottom'
                                },
                                labels: response.data.graficoDel.options,
                                dataLabels: {
                                    enabled: true,
                                    style: {
                                        colors: ['#000'],
                                        fontWeight: 'bold'
                                    },
                                    dropShadow: {
                                        enabled: false,
                                        top: 1,
                                        left: 1,
                                        blur: 1,
                                        color: '#000',
                                        opacity: 0.45
                                    },
                                    formatter: function (val, opt) {
                                        var i = opt.seriesIndex;
                                        return (opt.w.config.labels[i]) + ": " + val.toFixed(2) + "% (" + opt.w.globals.series[i] + ")";
                                    },
                                },
                                plotOptions: {
                                    pie: {
                                        dataLabels: {
                                            position: 'left',
                                            fontWeight: 'normal',
                                            offset: -33, // Moving the label position on slice
                                        }
                                    }
                                },
                                responsive: [{
                                    breakpoint: 480,
                                    options: {
                                        chart: {
                                            width: 200
                                        },
                                        legend: {
                                            position: 'bottom',
                                            fontWeight: 'normal'
                                        }
                                    }
                                }]
                            },
                            media: response.data.graficoDel.media
                        };
                    } else {
                        response.data.graficoDel = {
                            options: {},
                            series: [],
                            media: 0
                        }
                    }
                    if (response.data.graficoDelMedioDias != null) {
                        response.data.graficoDelMedioDias = {
                            options: {
                                colors: ['var(--primary-color)'],
                                chart: {
                                    id: "basic-bar",
                                    animations: {
                                        speed: 300
                                    },
                                },
                                dataLabels: {
                                    position: 'top',
                                    enabled: true,
                                    style: {
                                        fontWeight: 'normal',
                                        colors: ['#000']
                                    },
                                    offsetY: -20
                                },
                                plotOptions: {
                                    bar: {
                                        distributed: false,
                                        horizontal: false,
                                        dataLabels: {
                                            position: 'top',
                                            fontWeight: 'normal'
                                        }
                                    }
                                },
                                xaxis: {
                                    enabled: false,
                                    labels: {
                                        rotate: -45,
                                        type: 'category',
                                        formatter: function (val, index) {
                                            if (val && typeof val === 'string') {
                                                return val.replace("-", "/")
                                            }
                                        }
                                    },
                                    style: {
                                        fontSize: '7px'
                                    },
                                    categories: response.data.graficoDelMedioDias.options
                                },
                                yaxis: {
                                    labels: {
                                        formatter: function (val, index) {
                                            return Math.round(val)
                                        }
                                    }
                                },
                                tooltip: {
                                    y: {
                                        formatter: function (value, { series, seriesIndex, w }) {
                                            if (seriesIndex == 0) {
                                                return Math.round(value)
                                            } else {
                                                return value
                                            }
                                        }
                                    }
                                }
                            },
                            series: [
                                {
                                    name: "DEL",
                                    data: response.data.graficoDelMedioDias.series[0],
                                    colors: 'var(--primary-color)',
                                }
                            ],
                            media: response.data.graficoDelMedioDias.media
                        };
                    } else {
                        response.data.graficoDelMedioDias = {
                            options: {},
                            series: [],
                            media: 0
                        }
                    }
                    if (response.data.graficoDistribuicaoPartos != null) {
                        response.data.graficoDistribuicaoPartos = {
                            series: response.data.graficoDistribuicaoPartos.series[0],
                            options: {
                                colors: ['var(--primary-color)', '#cc2d42', '#d4ae33', '#426cf5', '#b36ba2'],
                                chart: {
                                    type: 'pie',
                                },
                                legend: {
                                    position: 'bottom'
                                },
                                labels: response.data.graficoDistribuicaoPartos.options,
                                dataLabels: {
                                    enabled: true,
                                    formatter: function (val, opt) {
                                        var i = opt.seriesIndex;
                                        return val.toFixed(2) + '% (' + opt.w.globals.series[i] + ')';
                                    },
                                    style: {
                                        colors: ['#000'],
                                        fontWeight: 'bold'
                                    },
                                    dropShadow: {
                                        enabled: false,
                                        top: 1,
                                        left: 1,
                                        blur: 1,
                                        color: '#000',
                                        opacity: 0.45
                                    },
                                },
                                plotOptions: {
                                    pie: {
                                        dataLabels: {
                                            position: 'top',
                                            offset: -10,
                                        }
                                    }
                                },
                            },
                            responsive: [{
                                breakpoint: 480,
                                options: {
                                    chart: {
                                        width: 200
                                    },
                                    legend: {
                                        position: 'bottom',
                                        fontWeight: 'normal'
                                    }
                                }
                            }]
                        };
                    } else {
                        response.data.graficoDistribuicaoPartos = {
                            options: {},
                            series: []
                        }
                    }
                    if (response.data.graficoIdadePrimeiroParto != null) {
                        response.data.graficoIdadePrimeiroParto = {
                            options: {
                                colors: ['var(--primary-color)'],
                                chart: {
                                    id: "basic-bar",
                                    animations: {
                                        speed: 300
                                    },
                                },
                                dataLabels: {
                                    position: 'top',
                                    enabled: true,
                                    style: {
                                        fontWeight: 'normal',
                                        colors: ['#000']
                                    },
                                    offsetY: -20
                                },
                                plotOptions: {
                                    bar: {
                                        distributed: false,
                                        horizontal: false,
                                        dataLabels: {
                                            position: 'top',
                                            fontWeight: 'normal'
                                        }
                                    }
                                },
                                xaxis: {
                                    enabled: false,
                                    labels: {
                                        rotate: -45,
                                        type: 'category',
                                        formatter: function (val, index) {
                                            if (val && typeof val === 'string') {
                                                return val.replace("-", "/")
                                            }
                                        }
                                    },
                                    style: {
                                        fontSize: '7px'
                                    },
                                    categories: response.data.graficoIdadePrimeiroParto.options
                                },
                                yaxis: {
                                    labels: {
                                        formatter: function (val, index) {
                                            return val.toFixed(1);
                                        }
                                    }
                                }
                            },
                            series: [
                                {
                                    name: "Meses",
                                    data: response.data.graficoIdadePrimeiroParto.series[0],
                                    colors: 'var(--primary-color)',
                                }
                            ]
                        };
                    } else {
                        response.data.graficoIdadePrimeiroParto = {
                            options: {},
                            series: []
                        }
                    }
                    if (response.data.graficoIntervaloPartos != null) {
                        response.data.graficoIntervaloPartos = {
                            options: {
                                colors: ['var(--primary-color)', '#000000'],
                                chart: {
                                    id: "basic-bar",
                                    animations: {
                                        speed: 300
                                    },
                                },
                                dataLabels: {
                                    position: 'top',
                                    enabled: true,
                                    style: {
                                        fontWeight: 'normal',
                                        colors: ['#000']
                                    },
                                    offsetY: -20
                                },
                                plotOptions: {
                                    bar: {
                                        distributed: false,
                                        horizontal: false,
                                        dataLabels: {
                                            position: 'top',
                                            fontWeight: 'normal'
                                        }
                                    }
                                },
                                xaxis: {
                                    enabled: false,
                                    labels: {
                                        rotate: -45,
                                        type: 'category',
                                        formatter: function (val, index) {
                                            if (val && typeof val === 'string') {
                                                return val.replace("-", "/")
                                            }
                                        }
                                    },
                                    style: {
                                        fontSize: '7px'
                                    },
                                    categories: response.data.graficoIntervaloPartos.options
                                },
                                yaxis: {
                                    labels: {
                                        formatter: function (val, index) {
                                            return val.toFixed(1);
                                        }
                                    }
                                },
                                tooltip: {
                                    y: {
                                        formatter: function (value, { series, seriesIndex, dataPointIndex, w }) {
                                            if (seriesIndex == 0) {
                                                return value.toFixed(1)
                                            } else {
                                                return value
                                            }
                                        }
                                    }
                                }
                            },
                            series: [
                                {
                                    name: "Meses",
                                    data: response.data.graficoIntervaloPartos.series[0],
                                    colors: 'var(--primary-color)'
                                }
                            ],
                            media: response.data.graficoIntervaloPartos.media
                        };
                    } else {
                        response.data.graficoIntervaloPartos = {
                            options: {},
                            series: [],
                            media: 0
                        }
                    }
                    if (response.data.graficoTaxaConcepcaoVacas != null) {
                        response.data.graficoTaxaConcepcaoVacas = {
                            options: {
                                colors: ['var(--primary-color)', '#000000'],
                                chart: {
                                    id: "basic-bar",
                                    animations: {
                                        speed: 300
                                    },
                                    stacked: true
                                },
                                dataLabels: {
                                    position: 'center',
                                    enabled: true,
                                    style: {
                                        fontWeight: 'normal',
                                        colors: ['#FFF']
                                    }
                                },
                                plotOptions: {
                                    bar: {
                                        distributed: false,
                                        horizontal: false,
                                        dataLabels: {
                                            position: 'top',
                                            fontWeight: 'normal'
                                        }
                                    }
                                },
                                xaxis: {
                                    enabled: false,
                                    labels: {
                                        rotate: -45,
                                        type: 'category',
                                        formatter: function formatter(val, index) {
                                            if (val && typeof val === 'string') {
                                                const parts = val.split('-');
                                                if (parts.length === 3) {
                                                    return `${parts[2]}/${parts[1]}/${parts[0]}`;
                                                }
                                            }
                                            return val;
                                        }
                                    },
                                    style: {
                                        fontSize: '7px'
                                    },
                                    categories: response.data.graficoTaxaConcepcaoVacas.options
                                },
                            },
                            series: [
                                {
                                    name: "Inseminações",
                                    data: response.data.graficoTaxaConcepcaoVacas.series[0],
                                    colors: 'var(--primary-color)'
                                },
                                {
                                    name: "Prenhezes",
                                    data: response.data.graficoTaxaConcepcaoVacas.series[1],
                                    colors: '#000000'
                                }
                            ],
                            media: response.data.graficoTaxaConcepcaoVacas.media
                        };
                    } else {
                        response.data.graficoTaxaConcepcaoVacas = {
                            options: {},
                            series: [],
                            media: 0
                        }
                    }

                    // Captura os dados brutos da API conforme especificado pelo usuário
                    const rawInseminacao = response.data.taxaInseminacaoVacas || response.data.graficoTaxaInseminacaoVacas;
                    const rawConcepcao = response.data.taxaConcepcaoVacas || response.data.graficoTaxaConcepcaoVacas;

                    if (rawInseminacao && rawConcepcao && rawInseminacao.series && rawConcepcao.series) {
                        let options = rawInseminacao.options || rawConcepcao.options || [];
                        let seriesPrenhez = [];
                        let somaPrenhez = 0;
                        let countPrenhez = 0;

                        const seriesIns = rawInseminacao.series;
                        const seriesCon = rawConcepcao.series;

                        // Função auxiliar para pegar os dados de uma série, lidando com formatos variados
                        const getSerieData = (series, index) => {
                            if (!series || !series[index]) return [];
                            if (Array.isArray(series[index])) return series[index];
                            if (series[index].data && Array.isArray(series[index].data)) return series[index].data;
                            return [];
                        };

                        const dataIns0 = getSerieData(seriesIns, 0); // Aptas
                        const dataIns1 = getSerieData(seriesIns, 1); // Inseminadas
                        const dataCon0 = getSerieData(seriesCon, 0); // Inseminações
                        const dataCon1 = getSerieData(seriesCon, 1); // Prenhezes

                        const totalPeriodos = dataIns0.length;

                        let seriesInseminacao = [];
                        let somaInseminacao = 0;
                        let seriesConcepcao21 = [];
                        let somaConcepcao21 = 0;

                        for (let i = 0; i < totalPeriodos; i++) {
                            let percentualIns = 0;
                            let percentualCon = 0;

                            try {
                                let aptas = dataIns0[i] || 0;
                                let inseminadas = dataIns1[i] || 0;
                                if (aptas > 0) percentualIns = (inseminadas * 100) / aptas;
                            } catch (e) { percentualIns = 0; }

                            seriesInseminacao.push(percentualIns);
                            if (percentualIns > 0) somaInseminacao += percentualIns;

                            try {
                                let inseminacoesTotal = dataCon0[i] || 0;
                                let prenhezesTotal = dataCon1[i] || 0;
                                if (inseminacoesTotal > 0) percentualCon = (prenhezesTotal * 100) / inseminacoesTotal;
                            } catch (e) { percentualCon = 0; }

                            seriesConcepcao21.push(percentualCon);
                            if (percentualCon > 0) somaConcepcao21 += percentualCon;

                            let taxaPrenhez = (percentualCon * percentualIns) / 100;
                            seriesPrenhez.push(taxaPrenhez);
                            if (taxaPrenhez > 0) somaPrenhez += taxaPrenhez;
                        }

                        // Lógica de Média do Mobile
                        const anoFiltro = parseInt(filterModel.periodo);
                        const anoAtual = new Date().getFullYear();
                        const inicioOffset = (anoFiltro === anoAtual) ? 2 : 0;
                        const periodosConsiderados = totalPeriodos - inicioOffset;

                        response.data.graficoTaxaPrenhez21DiasVacas = {
                            options: options,
                            series: [{ name: "Taxa de Prenhez", data: seriesPrenhez }],
                            media: periodosConsiderados > 0 ? (somaPrenhez / periodosConsiderados) : 0
                        };

                        response.data.graficoTaxaInseminacao21DiasVacas = {
                            options: options,
                            series: [{ name: "Taxa de Inseminação", data: seriesInseminacao }],
                            media: periodosConsiderados > 0 ? (somaInseminacao / periodosConsiderados) : 0
                        };

                        response.data.graficoTaxaConcepcao21DiasVacas = {
                            options: options,
                            series: [{ name: "Taxa de Concepção", data: seriesConcepcao21 }],
                            media: periodosConsiderados > 0 ? (somaConcepcao21 / periodosConsiderados) : 0
                        };
                    }

                    // Captura os dados brutos da API para Novilhas
                    const rawInseminacaoNov = response.data.taxaInseminacaoNovilhas || response.data.graficoTaxaInseminacaoNovilhas;
                    const rawConcepcaoNov = response.data.taxaConcepcaoNovilhas || response.data.graficoTaxaConcepcaoNovilhas;

                    if (rawInseminacaoNov && rawConcepcaoNov && rawInseminacaoNov.series && rawConcepcaoNov.series) {
                        let optionsNov = rawInseminacaoNov.options || rawConcepcaoNov.options || [];
                        let seriesPrenhezNov = [];
                        let somaPrenhezNov = 0;
                        let countPrenhezNov = 0;

                        const seriesInsNov = rawInseminacaoNov.series;
                        const seriesConNov = rawConcepcaoNov.series;

                        const getSerieData = (series, index) => {
                            if (!series || !series[index]) return [];
                            if (Array.isArray(series[index])) return series[index];
                            if (series[index].data && Array.isArray(series[index].data)) return series[index].data;
                            return [];
                        };

                        const dataInsNov0 = getSerieData(seriesInsNov, 0); // Aptas
                        const dataInsNov1 = getSerieData(seriesInsNov, 1); // Inseminadas
                        const dataConNov0 = getSerieData(seriesConNov, 0); // Inseminações
                        const dataConNov1 = getSerieData(seriesConNov, 1); // Prenhezes

                        const totalPeriodosNov = dataInsNov0.length;

                        let seriesInseminacaoNov = [];
                        let somaInseminacaoNov = 0;
                        let seriesConcepcao21Nov = [];
                        let somaConcepcao21Nov = 0;

                        for (let i = 0; i < totalPeriodosNov; i++) {
                            let percentualIns = 0;
                            let percentualCon = 0;

                            try {
                                let aptas = dataInsNov0[i] || 0;
                                let inseminadas = dataInsNov1[i] || 0;
                                if (aptas > 0) percentualIns = (inseminadas * 100) / aptas;
                            } catch (e) { percentualIns = 0; }

                            seriesInseminacaoNov.push(percentualIns);
                            if (percentualIns > 0) somaInseminacaoNov += percentualIns;

                            try {
                                let inseminacoesTotal = dataConNov0[i] || 0;
                                let prenhezesTotal = dataConNov1[i] || 0;
                                if (inseminacoesTotal > 0) percentualCon = (prenhezesTotal * 100) / inseminacoesTotal;
                            } catch (e) { percentualCon = 0; }

                            seriesConcepcao21Nov.push(percentualCon);
                            if (percentualCon > 0) somaConcepcao21Nov += percentualCon;

                            let taxaPrenhez = (percentualCon * percentualIns) / 100;
                            seriesPrenhezNov.push(taxaPrenhez);
                            if (taxaPrenhez > 0) somaPrenhezNov += taxaPrenhez;
                        }

                        // Lógica de Média do Mobile para Novilhas
                        const anoFiltro = parseInt(filterModel.periodo);
                        const anoAtual = new Date().getFullYear();
                        const inicioOffset = (anoFiltro === anoAtual) ? 2 : 0;
                        const periodosConsideradosNov = totalPeriodosNov - inicioOffset;

                        response.data.graficoTaxaPrenhez21DiasNovilhas = {
                            options: optionsNov,
                            series: [{ name: "Taxa de Prenhez Novilhas", data: seriesPrenhezNov }],
                            media: periodosConsideradosNov > 0 ? (somaPrenhezNov / periodosConsideradosNov) : 0
                        };

                        response.data.graficoTaxaInseminacao21DiasNovilhas = {
                            options: optionsNov,
                            series: [{ name: "Taxa de Inseminação Novilhas", data: seriesInseminacaoNov }],
                            media: periodosConsideradosNov > 0 ? (somaInseminacaoNov / periodosConsideradosNov) : 0
                        };

                        response.data.graficoTaxaConcepcao21DiasNovilhas = {
                            options: optionsNov,
                            series: [{ name: "Taxa de Concepção Novilhas", data: seriesConcepcao21Nov }],
                            media: periodosConsideradosNov > 0 ? (somaConcepcao21Nov / periodosConsideradosNov) : 0
                        };
                    }

                    // Formata final para exibição Novilhas
                    if (!response.data.graficoTaxaPrenhez21DiasNovilhas) {
                        response.data.graficoTaxaPrenhez21DiasNovilhas = {
                            options: [],
                            series: [],
                            media: 0
                        };
                    }

                    // Formata final para exibição (garante que o objeto exista mesmo que vazio)
                    if (!response.data.graficoTaxaPrenhez21DiasVacas) {
                        response.data.graficoTaxaPrenhez21DiasVacas = {
                            options: [],
                            series: [],
                            media: 0
                        };
                    }
                    if (response.data.graficoTaxaConcepcaoInseminadores != null) {
                        response.data.graficoTaxaConcepcaoInseminadores = {
                            options: {
                                colors: ['var(--primary-color)', '#000000'],
                                chart: {
                                    id: "basic-bar",
                                    animations: {
                                        speed: 300
                                    },
                                    stacked: true
                                },
                                dataLabels: {
                                    position: 'center',
                                    enabled: true,
                                    style: {
                                        fontWeight: 'normal',
                                        colors: ['#FFF']
                                    }
                                },
                                plotOptions: {
                                    bar: {
                                        distributed: false,
                                        horizontal: false,
                                        dataLabels: {
                                            position: 'top',
                                            fontWeight: 'normal'
                                        }
                                    }
                                },
                                xaxis: {
                                    enabled: false,
                                    labels: {
                                        rotate: -45,
                                        type: 'category',
                                        formatter: function formatter(val, index) {
                                            if (val && typeof val === 'string') {
                                                const parts = val.split('-');
                                                if (parts.length === 3) {
                                                    return `${parts[2]}/${parts[1]}/${parts[0]}`;
                                                }
                                            }
                                            return val;
                                        }
                                    },
                                    style: {
                                        fontSize: '7px'
                                    },
                                    categories: response.data.graficoTaxaConcepcaoInseminadores.options
                                },
                            },
                            series: [
                                {
                                    name: "Inseminações",
                                    data: response.data.graficoTaxaConcepcaoInseminadores.series[0],
                                    colors: 'var(--primary-color)'
                                },
                                {
                                    name: "Prenhezes",
                                    data: response.data.graficoTaxaConcepcaoInseminadores.series[1],
                                    colors: '#000000'
                                }
                            ]
                        };
                    } else {
                        response.data.graficoTaxaConcepcaoInseminadores = {
                            options: {},
                            series: []
                        }
                    }
                    if (response.data.graficoTaxaConcepcaoTouros != null) {
                        response.data.graficoTaxaConcepcaoTouros = {
                            options: {
                                colors: ['var(--primary-color)', '#000000'],
                                chart: {
                                    id: "basic-bar",
                                    animations: {
                                        speed: 300
                                    },
                                    stacked: true
                                },
                                dataLabels: {
                                    position: 'center',
                                    enabled: true,
                                    style: {
                                        fontWeight: 'normal',
                                        colors: ['#FFF']
                                    }
                                },
                                plotOptions: {
                                    bar: {
                                        distributed: false,
                                        horizontal: false,
                                        dataLabels: {
                                            position: 'top',
                                            fontWeight: 'normal'
                                        }
                                    }
                                },
                                xaxis: {
                                    enabled: false,
                                    labels: {
                                        rotate: -55,
                                        type: 'category',
                                        formatter: function formatter(val, index) {
                                            if (val && typeof val === 'string') {
                                                const parts = val.split('-');
                                                if (parts.length === 3) {
                                                    return `${parts[2]}/${parts[1]}/${parts[0]}`;
                                                } else {
                                                    return val.substring(0, 5);
                                                }
                                            }
                                            return val;
                                        }
                                    },
                                    style: {
                                        fontSize: '6px'
                                    },
                                    categories: response.data.graficoTaxaConcepcaoTouros.options
                                },
                            },
                            series: [
                                {
                                    name: "Inseminações",
                                    data: response.data.graficoTaxaConcepcaoTouros.series[0],
                                    colors: 'var(--primary-color)'
                                },
                                {
                                    name: "Prenhezes",
                                    data: response.data.graficoTaxaConcepcaoTouros.series[1],
                                    colors: '#000000'
                                }
                            ]
                        };
                    } else {
                        response.data.graficoTaxaConcepcaoTouros = {
                            options: {},
                            series: []
                        }
                    }
                    if (response.data.graficoProducaoPorLote != null) {
                        response.data.graficoProducaoPorLote = {
                            series: response.data.graficoProducaoPorLote.series[0],
                            options: {
                                colors: ['var(--primary-color)', '#cc2d42', '#d4ae33', '#426cf5', '#b36ba2'],
                                chart: {
                                    type: 'pie'
                                },
                                legend: {
                                    position: 'bottom'
                                },
                                labels: response.data.graficoProducaoPorLote.options,
                                dataLabels: {
                                    enabled: true,
                                    style: {
                                        colors: ['#000'],
                                        fontWeight: 'bold'
                                    },
                                    dropShadow: {
                                        enabled: false,
                                        top: 1,
                                        left: 1,
                                        blur: 1,
                                        color: '#000',
                                        opacity: 0.45
                                    },
                                    formatter: function (val, opt) {
                                        var i = opt.seriesIndex;
                                        return (opt.w.config.labels[i]) + ": " + val.toFixed(2) + "% (" + opt.w.globals.series[i] + ")";
                                    },
                                },
                                plotOptions: {
                                    pie: {
                                        dataLabels: {
                                            position: 'left',
                                            fontWeight: 'normal',
                                            offset: -33, // Moving the label position on slice
                                        }
                                    }
                                },
                                responsive: [{
                                    breakpoint: 480,
                                    options: {
                                        chart: {
                                            width: 200
                                        },
                                        legend: {
                                            position: 'bottom',
                                            fontWeight: 'normal'
                                        }
                                    }
                                }]
                            },
                        };
                    } else {
                        response.data.graficoProducaoPorLote = {
                            options: {},
                            series: []
                        }
                    }
                    if (response.data.graficoProducaoNumeroPartos != null) {
                        response.data.graficoProducaoNumeroPartos = {
                            series: response.data.graficoProducaoNumeroPartos.series[0],
                            options: {
                                colors: ['var(--primary-color)', '#cc2d42', '#d4ae33', '#426cf5', '#b36ba2'],
                                chart: {
                                    type: 'pie'
                                },
                                legend: {
                                    position: 'bottom'
                                },
                                labels: response.data.graficoProducaoNumeroPartos.options,
                                dataLabels: {
                                    enabled: true,
                                    style: {
                                        colors: ['#000'],
                                        fontWeight: 'bold'
                                    },
                                    dropShadow: {
                                        enabled: false,
                                        top: 1,
                                        left: 1,
                                        blur: 1,
                                        color: '#000',
                                        opacity: 0.45
                                    },
                                    formatter: function (val, opt) {
                                        var i = opt.seriesIndex;
                                        return (opt.w.config.labels[i]) + ": " + val.toFixed(2) + "% (" + opt.w.globals.series[i] + "L)";
                                    },
                                },
                                plotOptions: {
                                    pie: {
                                        dataLabels: {
                                            position: 'left',
                                            fontWeight: 'normal',
                                            offset: -33, // Moving the label position on slice
                                        }
                                    }
                                },
                                responsive: [{
                                    breakpoint: 480,
                                    options: {
                                        chart: {
                                            width: 200
                                        },
                                        legend: {
                                            position: 'bottom',
                                            fontWeight: 'normal'
                                        }
                                    }
                                }]
                            },
                        };
                    } else {
                        response.data.graficoProducaoNumeroPartos = {
                            options: {},
                            series: []
                        }
                    }
                    if (response.data.graficoProducaoPorDel != null) {
                        response.data.graficoProducaoPorDel = {
                            series: response.data.graficoProducaoPorDel.series[0],
                            options: {
                                colors: ['var(--primary-color)', '#cc2d42', '#d4ae33', '#426cf5', '#b36ba2'],
                                chart: {
                                    type: 'pie'
                                },
                                legend: {
                                    position: 'bottom'
                                },
                                labels: response.data.graficoProducaoPorDel.options,
                                dataLabels: {
                                    enabled: true,
                                    style: {
                                        colors: ['#000'],
                                        fontWeight: 'bold'
                                    },
                                    dropShadow: {
                                        enabled: false,
                                        top: 1,
                                        left: 1,
                                        blur: 1,
                                        color: '#000',
                                        opacity: 0.45
                                    },
                                    formatter: function (val, opt) {
                                        var i = opt.seriesIndex;
                                        return (opt.w.config.labels[i]) + ": " + val.toFixed(2) + "% (" + (opt.w.globals.series[i]).toFixed(2) + ")";
                                    },
                                },
                                plotOptions: {
                                    pie: {
                                        dataLabels: {
                                            position: 'left',
                                            fontWeight: 'normal',
                                            offset: -33
                                            // Moving the label position on slice
                                        }
                                    }
                                },
                                responsive: [{
                                    breakpoint: 480,
                                    options: {
                                        chart: {
                                            width: 200
                                        },
                                        legend: {
                                            position: 'bottom',
                                            fontWeight: 'normal'
                                        }
                                    }
                                }]
                            },
                            media: response.data.graficoProducaoPorDel.media
                        };
                    } else {
                        response.data.graficoProducaoPorDel = {
                            options: {},
                            series: [],
                            media: 0
                        }
                    }
                    if (response.data.graficoIntervaloPartoAtePrimeiraInseminacao != null) {
                        response.data.graficoIntervaloPartoAtePrimeiraInseminacao = {
                            options: {
                                colors: ['var(--primary-color)'],
                                chart: {
                                    id: "basic-bar",
                                    animations: {
                                        speed: 300
                                    },
                                },
                                dataLabels: {
                                    position: 'top',
                                    enabled: true,
                                    style: {
                                        fontWeight: 'normal',
                                        colors: ['#000']
                                    },
                                    offsetY: -20
                                },
                                plotOptions: {
                                    bar: {
                                        distributed: false,
                                        horizontal: false,
                                        dataLabels: {
                                            position: 'top',
                                            fontWeight: 'normal'
                                        }
                                    }
                                },
                                xaxis: {
                                    enabled: false,
                                    labels: {
                                        rotate: -45,
                                        type: 'category',
                                        formatter: function (val, index) {
                                            if (val && typeof val === 'string') {
                                                return val.replace(/-/g, "/");
                                            }
                                        }
                                    },
                                    style: {
                                        fontSize: '7px'
                                    },
                                    categories: response.data.graficoIntervaloPartoAtePrimeiraInseminacao.options
                                },
                                yaxis: {
                                    labels: {
                                        formatter: function (val, index) {
                                            return Math.round(val)
                                        }
                                    }
                                },
                                tooltip: {
                                    y: {
                                        formatter: function (value, { series, seriesIndex, dataPointIndex, w }) {
                                            if (seriesIndex == 0) {
                                                return Math.round(value)
                                            } else {
                                                return value
                                            }
                                        }
                                    }
                                }
                            },
                            series: [
                                {
                                    name: "Dias",
                                    data: response.data.graficoIntervaloPartoAtePrimeiraInseminacao.series[0],
                                    colors: 'var(--primary-color)'
                                }
                            ],
                            media: response.data.graficoIntervaloPartoAtePrimeiraInseminacao.media
                        };
                    } else {
                        response.data.graficoIntervaloPartoAtePrimeiraInseminacao = {
                            options: {},
                            series: []
                        }
                    }
                    if (response.data.graficoGorduraLeiteProteina != null) {
                        response.data.graficoGorduraLeiteProteina = {
                            options: {
                                colors: ['var(--primary-color)'],
                                chart: {
                                    id: "basic-bar",
                                    animations: {
                                        speed: 300
                                    },
                                },
                                dataLabels: {
                                    position: 'top',
                                    enabled: true,
                                    style: {
                                        fontWeight: 'normal',
                                        colors: ['#000']
                                    },
                                    offsetY: -20
                                },
                                plotOptions: {
                                    bar: {
                                        distributed: false,
                                        horizontal: false,
                                        dataLabels: {
                                            position: 'top',
                                            fontWeight: 'normal'
                                        }
                                    }
                                },
                                xaxis: {
                                    enabled: false,
                                    labels: {
                                        rotate: -45,
                                        type: 'category',
                                        formatter: function (val, index) {
                                            if (val && typeof val === 'string') {
                                                return val.replace(/-/g, "/");
                                            }
                                        }
                                    },
                                    style: {
                                        fontSize: '7px'
                                    },
                                    categories: response.data.graficoGorduraLeiteProteina.options
                                },
                                yaxis: {
                                    labels: {
                                        formatter: function (val, index) {
                                            return val.toFixed(2);
                                        }
                                    }
                                },
                                tooltip: {
                                    y: {
                                        formatter: function (value, { series, seriesIndex, w }) {
                                            if (seriesIndex == 0) {
                                                return value.toFixed(2)
                                            } else {
                                                return value
                                            }
                                        }
                                    }
                                }
                            },
                            series: [
                                {
                                    name: "Relação",
                                    data: response.data.graficoGorduraLeiteProteina.series[0],
                                    colors: 'var(--primary-color)'
                                }
                            ]
                        };
                    } else {
                        response.data.graficoGorduraLeiteProteina = {
                            options: {},
                            series: []
                        }
                    }
                    if (response.data.graficoAnimaisAtivosPorPeriodo != null) {
                        response.data.graficoAnimaisAtivosPorPeriodo = {
                            options: {
                                colors: ['var(--primary-color)'],
                                chart: {
                                    id: "basic-bar",
                                    animations: {
                                        speed: 300
                                    },
                                },
                                dataLabels: {
                                    position: 'top',
                                    enabled: true,
                                    style: {
                                        fontWeight: 'normal',
                                        colors: ['#000']
                                    },
                                    offsetY: -20
                                },
                                plotOptions: {
                                    bar: {
                                        distributed: false,
                                        horizontal: false,
                                        dataLabels: {
                                            position: 'top',
                                            fontWeight: 'normal'
                                        }
                                    }
                                },
                                xaxis: {
                                    enabled: false,
                                    labels: {
                                        rotate: -45,
                                        type: 'category',
                                        formatter: function (val, index) {
                                            if (val && typeof val === 'string') {
                                                return val.replace(/-/g, "/");
                                            }
                                        }
                                    },
                                    style: {
                                        fontSize: '7px'
                                    },
                                    categories: response.data.graficoAnimaisAtivosPorPeriodo.options
                                }
                            },
                            series: [
                                {
                                    name: "Animais ativos",
                                    data: response.data.graficoAnimaisAtivosPorPeriodo.series[1],
                                    colors: 'var(--primary-color)'
                                }
                            ]
                        };
                    } else {
                        response.data.graficoAnimaisAtivosPorPeriodo = {
                            options: {},
                            series: []
                        }
                    }
                    if (response.data.graficoIndicadoresTanques != null) {
                        response.data.graficoIndicadoresTanques = {
                            options: {
                                colors: ['#FF6976', '#769AFF', '#E499D1', '#D4AE33'],
                                chart: {
                                    id: "basic-bar",
                                    animations: {
                                        speed: 300
                                    },
                                },
                                dataLabels: {
                                    position: 'top',
                                    enabled: false,
                                    style: {
                                        fontWeight: 'normal',
                                        colors: ['#000']
                                    },
                                    offsetY: -20
                                },
                                plotOptions: {
                                    bar: {
                                        distributed: false,
                                        horizontal: false,
                                        dataLabels: {
                                            position: 'top',
                                            fontWeight: 'normal'
                                        }
                                    }
                                },
                                xaxis: {
                                    enabled: false,
                                    labels: {
                                        rotate: -45,
                                        type: 'category',
                                        formatter: function (val, index) {
                                            if (val && typeof val === 'string') {
                                                return val.replace("-", "/")
                                            }
                                        }
                                    },
                                    style: {
                                        fontSize: '7px'
                                    },
                                    categories: response.data.graficoIndicadoresTanques.options
                                },
                                yaxis: {
                                    labels: {
                                        formatter: function (val, index) {
                                            if (index == 1) {
                                                return val.toFixed(1);
                                            } else {
                                                return val.toFixed(2);
                                            }
                                        }
                                    }
                                },
                                tooltip: {
                                    y: {
                                        formatter: function (value, { series, seriesIndex, dataPointIndex, w }) {
                                            if (seriesIndex == 0) {
                                                return value.toFixed(1);
                                            } else {
                                                return value.toFixed(2);
                                            }
                                        }
                                    }
                                }
                            },
                            series: [
                                {
                                    name: "Gordura",
                                    data: response.data.graficoIndicadoresTanques.series[0],
                                    colors: '#FF6976'
                                },
                                {
                                    name: "Proteína",
                                    data: response.data.graficoIndicadoresTanques.series[1],
                                    colors: '#769AFF',
                                },
                                {
                                    name: "Ureia",
                                    data: response.data.graficoIndicadoresTanques.series[2],
                                    colors: '#E499D1'
                                },
                                {
                                    name: "Média litros/dia",
                                    data: response.data.graficoIndicadoresTanques.series[3],
                                    colors: '#D4AE33'
                                },
                            ]
                        };
                    } else {
                        response.data.graficoIndicadoresTanques = {
                            options: {},
                            series: []
                        }
                    }
                    if (response.data.graficoIntervaloPartoConcepcao != null) {
                        response.data.graficoIntervaloPartoConcepcao = {
                            options: {
                                colors: ['var(--primary-color)'],
                                chart: {
                                    id: "basic-bar",
                                    animations: {
                                        speed: 300
                                    },
                                },
                                dataLabels: {
                                    position: 'top',
                                    enabled: true,
                                    style: {
                                        fontWeight: 'normal',
                                        colors: ['#000']
                                    },
                                    offsetY: -20
                                },
                                plotOptions: {
                                    bar: {
                                        distributed: false,
                                        horizontal: false,
                                        dataLabels: {
                                            position: 'top',
                                            fontWeight: 'normal'
                                        }
                                    }
                                },
                                xaxis: {
                                    enabled: false,
                                    labels: {
                                        rotate: -45,
                                        type: 'category',
                                        formatter: function (val, index) {
                                            if (val && typeof val === 'string') {
                                                return val.replace("-", "/")
                                            }
                                        }
                                    },
                                    style: {
                                        fontSize: '7px'
                                    },
                                    categories: response.data.graficoIntervaloPartoConcepcao.options
                                },
                                yaxis: {
                                    labels: {
                                        formatter: function (val, index) {
                                            return val.toFixed(1);
                                        }
                                    }
                                },
                                tooltip: {
                                    y: {
                                        formatter: function (value, { series, seriesIndex, dataPointIndex, w }) {
                                            if (seriesIndex == 0) {
                                                return value.toFixed(1)
                                            } else {
                                                return value
                                            }
                                        }
                                    }
                                }
                            },
                            series: [
                                {
                                    name: "Dias",
                                    data: response.data.graficoIntervaloPartoConcepcao.series[0],
                                    colors: 'var(--primary-color)'
                                }
                            ]
                        };
                    } else {
                        response.data.graficoIntervaloPartoConcepcao = {
                            options: {},
                            series: []
                        }
                    }
                    if (response.data.graficoGanhoPesoDesmame != null) {
                        response.data.graficoGanhoPesoDesmame = {
                            options: {
                                colors: ['var(--primary-color)'],
                                chart: {
                                    id: "basic-bar",
                                    animations: {
                                        speed: 300
                                    },
                                },
                                dataLabels: {
                                    position: 'top',
                                    enabled: true,
                                    style: {
                                        fontWeight: 'normal',
                                        colors: ['#000']
                                    },
                                    offsetY: -20
                                },
                                plotOptions: {
                                    bar: {
                                        distributed: false,
                                        horizontal: false,
                                        dataLabels: {
                                            position: 'top',
                                            fontWeight: 'normal'
                                        }
                                    }
                                },
                                xaxis: {
                                    enabled: false,
                                    labels: {
                                        rotate: -45,
                                        type: 'category',
                                        formatter: function (val, index) {
                                            if (val && typeof val === 'string') {
                                                return val.replace("-", "/")
                                            }
                                        }
                                    },
                                    style: {
                                        fontSize: '7px'
                                    },
                                    categories: response.data.graficoGanhoPesoDesmame.options
                                },
                                yaxis: {
                                    labels: {
                                        formatter: function (val, index) {
                                            return val.toFixed(1);
                                        }
                                    }
                                },
                                tooltip: {
                                    y: {
                                        formatter: function (value, { series, seriesIndex, dataPointIndex, w }) {
                                            if (seriesIndex == 0) {
                                                return value.toFixed(1)
                                            } else {
                                                return value
                                            }
                                        }
                                    }
                                }
                            },
                            series: [
                                {
                                    name: "Kg/Dia",
                                    data: response.data.graficoGanhoPesoDesmame.series[0],
                                    colors: 'var(--primary-color)'
                                }
                            ]
                        };
                    } else {
                        response.data.graficoGanhoPesoDesmame = {
                            options: {},
                            series: []
                        }
                    }


                }

                dispatch(editHomeDetails(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err);
                //   alerts.error(err);
            });
    };
}


export function editHomeDetails(home) {
    return {
        type: "HOME_DETAIL",
        fazendas: home.fazendas,
        empresas: home.empresas,
        total_usuarios: home.total_usuarios,
        total_animais: home.total_animais,
        total_fazendas: home.total_fazendas,
        graficoTanques: home.graficoTanques,
        graficoAnimaisGrupos: home.graficoAnimaisGrupos,
        graficoDistribuicaoPartos: home.graficoDistribuicaoPartos,
        graficoIdadePrimeiroParto: home.graficoIdadePrimeiroParto,
        graficoIntervaloPartos: home.graficoIntervaloPartos,
        graficoTaxaConcepcaoVacas: home.graficoTaxaConcepcaoVacas,
        graficoTaxaConcepcaoTouros: home.graficoTaxaConcepcaoTouros,
        graficoTaxaConcepcaoInseminadores: home.graficoTaxaConcepcaoInseminadores,
        graficoIntervaloPartoAtePrimeiraInseminacao: home.graficoIntervaloPartoAtePrimeiraInseminacao,
        graficoProducaoNumeroPartos: home.graficoProducaoNumeroPartos,
        graficoTaxaPrenhez21DiasVacas: home.graficoTaxaPrenhez21DiasVacas,
        graficoTaxaPrenhez21DiasNovilhas: home.graficoTaxaPrenhez21DiasNovilhas,
        graficoTaxaInseminacao21DiasVacas: home.graficoTaxaInseminacao21DiasVacas,
        graficoTaxaInseminacao21DiasNovilhas: home.graficoTaxaInseminacao21DiasNovilhas,
        graficoTaxaConcepcao21DiasVacas: home.graficoTaxaConcepcao21DiasVacas,
        graficoTaxaConcepcao21DiasNovilhas: home.graficoTaxaConcepcao21DiasNovilhas,
        graficoProducaoPorLote: home.graficoProducaoPorLote,
        graficoProducaoPorDel: home.graficoProducaoPorDel,
        graficoDel: home.graficoDel,
        graficoDelMedioDias: home.graficoDelMedioDias,
        graficoGorduraLeiteProteina: home.graficoGorduraLeiteProteina,
        graficoAnimaisAtivosPorPeriodo: home.graficoAnimaisAtivosPorPeriodo,
        graficoIndicadoresTanques: home.graficoIndicadoresTanques,
        graficoIntervaloPartoConcepcao: home.graficoIntervaloPartoConcepcao,
        graficoGanhoPesoDesmame: home.graficoGanhoPesoDesmame
    }
}

function editHomeInfo(id, payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'home/' + id;
        homeService.put(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    dispatch(updatedUserInfo());
                    if (showWaiting) {
                        alerts.clean();
                    }
                    alerts.success(ret.message, '/home');
                } else {
                    alerts.warning(response.request.responseText);
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            });
    }
}

function onChangeProps(props, event) {
    return dispatch => {
        if (event.target.type === 'checkbox') {
            dispatch(handleOnChangeProps(props, event.target.checked));
        } else {
            dispatch(handleOnChangeProps(props, event.target.value));
        }
    };
}

export function changeHomesList(home) {
    return {
        type: "FETECHED_ALL_HOME",
        home: home
    }
}
export function handleOnChangeProps(props, value) {
    return {
        type: "HANDLE_ON_CHANGE",
        props: props,
        value: value
    }
}
export function editHomesDetails(home) {
    return {
        type: "HOME_DETAIL",
        total_fazendas: home.total_fazendas,
        total_animais: home.total_animais

    }
}
export function updatedUserInfo() {
    return {
        type: "HOME_UPDATED"
    }
}
export function createUserInfo() {
    return {
        type: "HOME_CREATED_SUCCESSFULLY"
    }
}
export function deleteHomesDetails() {
    return {
        type: "DELETED_HOME_DETAILS"
    }
}
export function clear() {
    return {
        type: "HOME_CLEAR"
    };
}